(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/free-reduction/random.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/free-reduction/random.js'); "use strict";

(function (svs) {
  svs.tipset.freeReduction.randomFloatBetween = function (min, max) {
    var fixed = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 4;
    var scale = Math.pow(10, fixed),
        num = svs.tipset.freeReduction.randIntBetween(min * scale, max * scale),
        numFixed = (num / scale).toFixed(fixed);
    return parseFloat(numFixed);
  };

  svs.tipset.freeReduction.randIntBetween = function (min, max) {
    return Math.floor(svs.tipset.freeReduction.random() * (max - min + 1) + min);
  }; 


  svs.tipset.freeReduction.random = function () {
    var arr = new Uint32Array(1);
    var crypto = window.crypto || window.msCrypto;
    crypto.getRandomValues(arr);
    return arr[0] / (0xffffffff + 1);
  };
})(svs);
 })(window);